import { isEmptyString, isObject } from "../Components/Editor/utils/common";
import { convertWhatsappToHtmlText } from "./editor";

const getText = (response: any, channel?: string) => {
  let text = "";
  if (response && response !== null && response.length > 0) {
    // Check for components structure first (new condition)
    const componentsMatch = response.find((item: any) => item.components);
    
    if (componentsMatch) {
      // Handle dynamic button components
      if (componentsMatch?.components?.button && 
          componentsMatch?.components.button?.type === "dynamic" &&
          Array.isArray(componentsMatch?.components?.button?.value) &&
          componentsMatch?.components?.button?.value?.length > 0) {
        
        const firstButton = componentsMatch?.components?.button?.value?.[0];
        if (firstButton && firstButton?.value) {
          text = firstButton?.value;
        } else {
          text = "Untitled";
        }
      }
      // Handle carousel components
      else if (componentsMatch?.components?.carousel && 
               componentsMatch?.components?.carousel?.type === "carousel" &&
               Array.isArray(componentsMatch?.components?.carousel?.value) &&
               componentsMatch?.components?.carousel?.value?.length > 0) {
        
        const firstCarouselItem = componentsMatch?.components?.carousel?.value[0];
        if (firstCarouselItem && 
            Array.isArray(firstCarouselItem?.buttons) && 
            firstCarouselItem?.buttons?.length > 0 &&
            firstCarouselItem?.buttons?.[0]?.text) {
          text = firstCarouselItem?.buttons?.[0]?.text;
        } else {
          text = "Untitled";
        }
      }
      // Handle body components
      else if (componentsMatch?.components?.body && 
               Array.isArray(componentsMatch?.components?.body?.value) &&
               componentsMatch?.components?.body?.value?.length > 0) {
        
        const firstBodyItem = componentsMatch?.components?.body?.value?.[0];
        if (firstBodyItem && firstBodyItem?.value) {
          text = firstBodyItem?.value;
        } else {
          text = "Untitled";
        }
      }
      // Default for other component types
      else {
        text = "Untitled";
      }
    } else {
      // Existing functionality for other response types
      const match = response.filter(
        (item: any) =>
          item?.type === "text" ||
          item?.type === "carousel" ||
          item?.hasOwnProperty("interactive") ||
          item?.type === "image" ||
          item?.type === "video" ||
          item?.type === "document" ||
          item?.type === "file" ||
          item?.type==="location-node" ||
          item?.type === "share-location"
      );
      
      if (match.length > 0) {
        const first = match[0];

        if (first?.type === "file") {
          if (typeof first?.value === "string") {
            const trimmed = first.value.trim();
            text = trimmed === "" ? "Untitled" : trimmed;
          } else {
            text = "Untitled";
          }
        } else if (first?.value) {
          if (isObject(first?.value)) {
            if(first?.value?.address){
              text = !isEmptyString(first?.value?.address) ? first?.value?.address : "<p>Untitled</p>";
            }else{
              text = !isEmptyString(first?.value?.text) ? first?.value?.text : "<p>Untitled</p>";
            }
          } else if (Array.isArray(first?.value) && first?.value?.length > 0) {
            text = first?.value?.[0]?.text?.trim()? first?.value?.[0]?.text?.trim() || "Untitled" : "<p>Untitled</p>";
          } else if (typeof first?.value === "string") {
            const trimmed = first.value.trim();
            text = trimmed === "" ? "Untitled" : trimmed;
          } else {
            text = first?.value;
          }
        } else if (first?.text) {
          const trimmed = first.text.trim();
          text = trimmed === "" ? "Untitled" : trimmed;
        } else if (first?.interactive) {
          const trimmed = first.interactive?.body?.trim();
          text = trimmed === "" ? "Untitled" : trimmed;
        } else {
          text = "Untitled";
        }
      }
    }
  }

  // Check if text is empty HTML tags or just whitespace
  const isEmptyHtml = (str: string) => {
    // Remove HTML tags and check if remaining content is empty
    const textContent = str?.replace(/<[^>]*>/g, '').trim();
    return textContent === '';
  };
  // If text is empty or contains only empty HTML tags, set to "Untitled"
  if (!text || text.trim() === '' || isEmptyHtml(text)) {
    text = "Untitled";
  }

  if (channel === "whatsapp") {
    return convertWhatsappToHtmlText(text);
  }

  return text;
};
export default getText;